<template>
  <v-container grid-list-xs>
    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-card>
          <v-toolbar color="primary" dark>
            <v-toolbar-title>List of Groups</v-toolbar-title>
            <v-spacer></v-spacer>
            <addGroup :AtFinshed="GoupLoad"></addGroup>
          </v-toolbar>
          <v-card-text>
            <v-list>
              <v-list-group
                prepend-icon="fas fa-users-cog"
                v-for="(item, index) in groups"
                :key="index"
                no-action
                color="green"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.GroupName }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-icon>
                    <EditGroup
                      :AtFinshed="GoupLoad"
                      :Name="item.GroupName"
                      :Routes="item.route"
                    ></EditGroup>
                  </v-list-item-icon>
                </template>

                <v-list-item
                  dense
                  link
                  v-for="(route, index) in item.route"
                  :key="index"
                >
                  <v-list-item-icon>
                    <v-icon color="green">fas fa-check</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title class="teal--text">{{
                    route
                  }}</v-list-item-title>
                </v-list-item>
              </v-list-group>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import addGroup from "@/components/Users/addGroup.vue";
import EditGroup from "@/components/Users/EditGroup.vue";
// import _ from "lodash";

export default {
  components: { addGroup, EditGroup },
  data() {
    return {
      groups: [],
    };
  },
  methods: {
    GoupLoad() {
      this.$store
        .dispatch("GET_ONLY", "/users/groups")
        .then(result => {
          this.groups = result.data.map(r => {
            return {
              ...r,
              route: r.route.sort(a => (a == "Home" ? -1 : 1)),
            };
          });
          // console.log(this.groups);
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.GoupLoad();
  },
};
</script>
